/**
 * Dock Config — 7 core app + Store + Launchpad
 * Removed from Dock (still in windowRegistry, accessible via Launchpad):
 * Terminal, Explorer, Twin, Training, Brain, Tasks, Settings, Wallet, Admin
 */
import {
    BookOpen, Bot,
    Briefcase, Calendar, Code2, FileText, FolderOpen, Globe, LayoutGrid, MessageCircle,
    Shield,
    Sparkles,
    Store as StoreIcon,
    Users
} from 'lucide-react'
import type { ElementType } from 'react'

export interface DockItemConfig {
  id: string
  label: string
  icon: ElementType
  path: string
  color: string
  separator?: boolean
  windowTitle?: string
  windowWidth?: number
  windowHeight?: number
  noPadding?: boolean
  adminOnly?: boolean
}

export const DOCK_ITEMS: DockItemConfig[] = [
  { id: 'flzhub',    label: 'FlzHub',    icon: MessageCircle, path: 'flzhub',          color: '#8b5cf6', windowTitle: 'FlzHub',       windowWidth: 860, windowHeight: 620, noPadding: true },
  { id: 'social',    label: 'Social',    icon: Users,         path: 'social-window',   color: '#3b82f6', windowTitle: 'Social',       windowWidth: 820, windowHeight: 600, noPadding: true },
  { id: 'work',      label: 'Work',      icon: Briefcase,     path: 'work-window',     color: '#f59e0b', windowTitle: 'Work',         windowWidth: 800, windowHeight: 580, noPadding: true },
  { id: 'research',  label: 'Research',  icon: BookOpen,      path: 'research-window', color: '#10b981', windowTitle: 'Research',     windowWidth: 800, windowHeight: 580, noPadding: true },
  { id: 'ask-ai',    label: 'Ask AI',    icon: Sparkles,      path: 'ask-ai',          color: '#6366f1', windowTitle: 'Ask AI',       windowWidth: 520, windowHeight: 480 },
  { id: 'agents',    label: 'Agents',    icon: Bot,           path: 'agents-window',   color: '#818cf8', windowTitle: 'Agents',       windowWidth: 800, windowHeight: 580, noPadding: true },

  { id: 'sep1', label: '', icon: LayoutGrid, path: '', color: '', separator: true },

  { id: 'store',     label: 'Store',     icon: StoreIcon,     path: 'store',           color: '#10b981', windowTitle: 'RunAI Store',  windowWidth: 860, windowHeight: 600, noPadding: true },
  { id: 'runfiles',  label: 'RunFiles',  icon: FolderOpen,    path: 'run-explorer',    color: '#f59e0b', windowTitle: 'RunFiles',     windowWidth: 900, windowHeight: 600 },
  { id: 'runweb',    label: 'RunBrowser', icon: Globe,         path: 'run-browser',     color: '#0ea5e9', windowTitle: 'RunBrowser',   windowWidth: 1000, windowHeight: 700 },
  { id: 'runcode',   label: 'RunCode',   icon: Code2,         path: 'run-code',        color: '#007acc', windowTitle: 'RunCode',      windowWidth: 1100, windowHeight: 700 },
  { id: 'runpad',    label: 'RunaiPad',  icon: FileText,      path: 'runai-pad',       color: '#8b5cf6', windowTitle: 'RunaiPad',     windowWidth: 900, windowHeight: 650 },
  { id: 'calendar',  label: 'Calendar',  icon: Calendar,      path: 'calendar',        color: '#ec4899', windowTitle: 'Calendar',     windowWidth: 950, windowHeight: 700 },
  { id: 'launchpad', label: 'Launchpad', icon: LayoutGrid,    path: 'launchpad',      color: '#6366f1', windowTitle: 'Launchpad',    windowWidth: 860, windowHeight: 620, noPadding: true },
  { id: 'admin',     label: 'Admin',     icon: Shield,        path: 'admin-panel',     color: '#ef4444', windowTitle: 'Admin Panel',  windowWidth: 1100, windowHeight: 700, adminOnly: true },
]
